import React, { useState, useEffect } from "react";
import { CreatePost } from "@hedgefund/shared";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getPost } from "../NewsFeed/actions";
import {
  // createUploaderSuccess,
  createPost,
  postDetail,
  updatePost,
} from "./actions";
import { alertService } from "@hedgefund/shared/src/Alert";

const CreateNewPost = ({ location }) => {
  let history = useHistory();
  const [message, setMessage] = useState(null);
  const createNewPostState = useSelector((state) => state.createNewPosts);
  const getNewPostState = useSelector((state) => state.getNewPosts);
  const { postCount, pageCount } = getNewPostState;
  const { loading, getPostDetails } = createNewPostState;
  const splitId = location.pathname.split("/updatepost/:");
  const id = splitId[1];
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(postDetail(id));
    }
  }, [id]);

  const onSuccess = () => {
    alertService.success("Post Created!", { autoClose: true });
    setTimeout(() => {
      dispatch(
        getPost({
          page: pageCount,
          perPage: postCount,
        })
      );
      history.push("/newsfeed");
    }, 2000);
  };

  const onSubmitNewPostHandler = (value) => {
    if (id) {
      dispatch(updatePost(value));
    } else {
      dispatch(createPost(value, onSuccess));
    }
  };
  return (
    <CreatePost
      onSubmitNewPostHandler={onSubmitNewPostHandler}
      loading={loading}
      message={message}
      getPostDetails={getPostDetails}
      type={true}
      recordId={id}
    />
  );
};

export default CreateNewPost;
